import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';
import 'lazysizes/lazysizes.min.js';
import 'flickity-bg-lazyload/bg-lazyload.js';
import './../../casadistance/dist/main-bundle.js';
import "sticky-kit/dist/sticky-kit.min.js";
import noUiSlider from "nouislider";


fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function make_twocol_sticky() {
	  $(".sticky-col .content-wrapper__inner").stick_in_parent({
	    offset_top: 200,
	  });
	}

	function make_singlecol_sticky() {
	  $(".sticky-col > .complex-project-graphic-wrapper").stick_in_parent({
	    offset_top: 95,
	  });
	}

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}

	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}	

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(window).height())));
	}
	function revealElements() {
		$('.reveal, .reveal-fade').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('revealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('revealed');
                }, 0);
            }
	        }
	    });
	}

	function endsWith(string, search){
	    return string.substring( string.length - search.length, string.length ) === search;
	}

		revealElements();
		$(window).scroll(function(){
		    revealElements();
		});

		if ($(window).width() < 768) {
		  $("#sidebar").trigger("sticky_kit:detach");
		} else {
		  make_twocol_sticky();
		}

		make_singlecol_sticky();

		var siteHeader = $('.site-header');

		window.onscroll = function () { 
		    "use strict";
			var docViewTop = $(window).scrollTop();
			if (docViewTop >= 1) {
				$('.site-header').addClass("site-header--background");
			} else {
				$('.site-header').removeClass("site-header--background");
			}	   			
		};

		$('.btn-secondary').append('<svg width="7px" height="11px" viewBox="0 0 6 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Lage" transform="translate(-346.000000, -3315.000000)" stroke="#2F698C"><polyline id="Rectangle" transform="translate(349.000000, 3320.500000) scale(-1, -1) rotate(90.000000) translate(-349.000000, -3320.500000) " points="354 3318 349 3323 344 3318"></polyline></g></g></svg>');
		

		/* Complex Filter */

		if ($(".complex-filter-wrapper")) {
		  $(".complex-filter-wrapper").prepend(
		    '<div class="filter-toggler"><svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <g id="Styleguide-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <g id="Desktop-HD" transform="translate(-59.000000, -698.000000)">            <text id="Bei-grossen-Überbauu" font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" letter-spacing="0.228571429" fill="#727477">                <tspan x="59" y="578">Bei grossen Überbauungen möchten sie die Option haben Filter </tspan>                <tspan x="59" y="600">einzublenden. Bei kleineren Überbauungen soll das Icon nicht erscheinen. </tspan>                <tspan x="59" y="622">Die Filter sollen sich beim anklicken des Icons oben hineinschieben. </tspan>                <tspan x="59" y="644"></tspan>                <tspan x="59" y="666">Icon: </tspan>                <tspan x="59" y="688"></tspan>                <tspan x="59" y="710"></tspan>                <tspan x="59" y="732"></tspan>                <tspan x="59" y="754">Filter:</tspan>            </text>            <g id="Group-2" transform="translate(59.000000, 698.000000)">                <line x1="0.5" y1="1.5" x2="17.5" y2="1.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="4.5" cy="1.5" r="1.5"></circle>                <line x1="0.5" y1="6.5" x2="17.5" y2="6.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="14.5" cy="6.5" r="1.5"></circle>                <line x1="0.5" y1="11.5" x2="17.5" y2="11.5" id="Line" stroke="#324542" stroke-linecap="round"></line>                <circle id="Oval" fill="#324542" cx="8.5" cy="11.5" r="1.5"></circle>            </g>        </g>    </g></svg> Filter</div>'
		  );
		}

		$(".filter-toggler").on('click', function () {
		  $(this).next().toggleClass("show-filters");
		});


		/* Complex List  */

		$('#filteroption-miete-grossto .filteroption-label').text('Brutto Miete');

		$('.complex-form-phone').find("input[name='complex-unit-inquiry[phone]']").each(function(ev)
		  {
		      if(!$(this).val()) { 
		     $(this).attr("placeholder", "Nummer");
		  }
		  });


		$('.col-status  > span  > span').text('');
		$('th.col-status').text('');
		$(".complex-unit-caret").html(
		  '<svg width="10px" height="5px" viewBox="0 0 13 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"> <g transform="translate(-1252.000000, -1210.000000)"  stroke-width="1.25"> <polyline points="1264 1211 1258.5 1217 1253 1211"></polyline> </g></g></svg>'
		);

		if ($('.col-r_purchase_price').length) {
			$('.complex-list-wrapper-collapsible').append('<div class="complex-availability-legend"><div class="availability-legend__available"><span></span>Verfügbar</div><div class="availability-legend__reserved"><span></span>Reserviert</div><div class="availability-legend__sold"><span></span>Verkauft</div></div>');
		} else {
			$('.complex-list-wrapper-collapsible').append('<div class="complex-availability-legend"><div class="availability-legend__available"><span></span>Verfügbar</div><div class="availability-legend__reserved"><span></span>Reserviert</div><div class="availability-legend__sold"><span></span>Vermietet</div></div>');
		}
		
		//Close Icon
		$(".complex-sendback-contact-form").prepend('<i class="fal fa-times"></i>');

		//wysiwyg alignright
		$('.alignright').after('<div style="clear: both;"></div>');

		document.addEventListener('lazybeforeunveil', function(e){
		    var bg = e.target.getAttribute('data-bg');
		    if(bg){
		        e.target.style.backgroundImage = 'url(' + bg + ')';
		    }
		});
		lazySizes.autoSizer.checkElems();

		$('.nav .menu-item-has-children > a').on('click', function(e){
			e.preventDefault();
			if ($(this).next().hasClass('sub-open')) {
				$('.nav .menu-item-has-children > a').next().removeClass('sub-open');
			} else {
				$('.nav .menu-item-has-children > a').next().removeClass('sub-open');
				$(this).next().addClass('sub-open');
			}
			return false;
		});


		$(".gallery-wrapper").lightGallery({
		  selector: ".wrapping-link",
		  thumbnails: false,
		});


		$(".bildkachel-wrapper").lightGallery({
		  selector: ".wrapping-link-image",
		  thumbnails: false,
		});

		$('.navbar-toggler').on('click', function(){
			if ($(this).hasClass('active-nav')) {
				$(this).removeClass('active-nav');
				$('.navbar-outer').removeClass('nav-bg');
			} else {
				$(this).addClass('active-nav');
				$('.navbar-outer').addClass('nav-bg');
			}
		});

		$('.navbar-collapse').on('shown.bs.collapse', function(){
			$('#footer').hide();
			$('.site-content').hide();
			$('.slider-outer').hide();
			$('.navbar-toggler').removeClass('dont-click');
		});

		$('.navbar-collapse').on('show.bs.collapse', function(){
			$('.navbar-toggler').addClass('dont-click');
		});

		$('.navbar-collapse').on('hidden.bs.collapse', function(){
			$('.navbar-toggler').removeClass('dont-click');
		});

		$('.navbar-collapse').on('hide.bs.collapse', function(){
			$('#footer').show();
			$('.site-content').show();
			$('.slider-outer').show();
			$('.navbar-toggler').addClass('dont-click');
		});

	  	//Slider für den Banner Bereich auf jeder Seite, mit Lazyload
	  	if ($('.slider-outer__slider').length) {
			var slider = new Flickity('.slider-outer__slider', {
				cellAlign: 'left',
				fade: true,
				imagesLoaded: true,
				pageDots: false,
				prevNextButtons: false,
				draggable: false,
				autoPlay: 5000,
				bgLazyLoad: true
			});
		}

		//Casadistance Mobile-list Klappbutton
		$('.casadistance__result').append('<div class="open-results">+</div>')

		$(".open-results").on('click', function () {
		  $(this).parent().toggleClass("list-full");
		  if($(this).parent().hasClass("list-full")){
		  	$('.open-results').text("-");
		  } else{
		  	$('.open-results').text("+");
		  }
		});

		$(".complex-unit-header-row").off('click');
		$('.complex-unit-header-row').off('click touchend');
		$('.complex-unit-header-row').off('mouseenter');

		$(".complex-unit-header-row").on('mouseenter', function(){
			//console.log('mouseenter0');
			highlightProjectUnit($(this));
		});

		$(".complex-unit-detail-row").on('mouseenter', function(){
			// console.log('mouseenter1');
			// console.log($(this).prev('.complex-unit-header-row'));
			highlightProjectUnit($(this).prev('.complex-unit-header-row'));
		});


		


		$("label[for^='complexFieldlegalName']").hide()
		$("input[id^='complexFieldlegalName']").hide()

		function highlightProjectUnit($headerRow, speed){
			speed = typeof speed !== 'undefined' ? speed : 0;
			var id = "#"+$headerRow.prop('id');
			$('.complex-project-graphic-interaction a').each(function(index, el) {
				// removeClass
				$(el).attr('class', function(index, classNames) {
					var re = /active/gi;
					classNames = classNames.replace(re, '');
				    return classNames;
				});
			});
			$('.complex-project-graphic-interaction a').each(function(iindex, iel) {
				if (endsWith($(iel).attr("xlink:href"), id)) {
					//addClass
					$(iel).attr('class', function(index, classNames) {
						var re = /active/gi;
						classNames = classNames.replace(re, '');
					    return classNames + ' active';
					});
				}
			});
			$('.complex-custom-overlays img').fadeOut(speed);
			var $targetOverlay = $('.complex-custom-overlays img[data-show-on-active-unit="'+id+'"]');
			$targetOverlay.addClass('active').fadeIn(speed);

			//lazy load
			if ($targetOverlay.data('src')) {
				$targetOverlay.prop('src', $targetOverlay.data('src'));
				$targetOverlay.data('src', null);
			}

			$('.complex-tooltip-unit-item').hide();
			if ($('.complex-project-graphic:hover').length !== 0) {
				$('.complex-tooltip-unit-item[data-unit="'+id+'"]').closest('.complex-tooltip').show();
			}
			$('.complex-tooltip-unit-item[data-unit="'+id+'"]').show();
		}



		function activateProjectUnit($headerRow){
			$('.complex-tooltip').hide();
			$('.complex-project-graphic-interaction a').each(function(index, el) {
				// removeClass
				$(el).attr('class', function(index, classNames) {
					var re = /active/gi;
					classNames = classNames.replace(re, '');
				    return classNames;
				});
			});



			if ($headerRow.hasClass('active')) {
				$headerRow.next().find('.detail-row-wrapper').slideUp('slow');
				$headerRow.removeClass('active');
				$headerRow.next().removeClass('active');
			} else {
		

				$headerRow.next().find('.detail-row-wrapper img').each(function(index, el) {
					if ($(el).data('src')) {
						$(el).prop('src',$(el).data('src'));
						$(el).prop('srcset',$(el).data('src'));
						$(el).data('src', null);
					}
				});

				//console.log(getCXMscrollOffset());

				if ($(window).width() >= 992) {
					var offset = '530';
				} else if($(window).width() >= 768){
					var offset = '430';
				} else {
					var offset = '330';
				}

				scrolltoheaderRow($headerRow, offset);

				$('.complex-unit-header-row.active').each(function(index, el) {

					$(el).next().find('.detail-row-wrapper').slideUp('slow');
					$(el).removeClass('active');
					$(el).next().removeClass('active');
				});


				$headerRow.next().find('.detail-row-wrapper').delay(300).slideDown('slow');
				$headerRow.addClass('active');
				$headerRow.next().addClass('active');

				/*$('html, body').animate({
			        scrollTop: $headerRow.next().find('.detail-row-wrapper').offset().top - 100
			    }, 500);*/

				highlightProjectUnit($headerRow);
			}
		}

		var dragging = false;
		$("body").on("touchmove", function(){
		      dragging = true;
		});
		$("body").on("touchstart", function(){
		    dragging = false;
		});

		
		$('.complex-unit-header-row').on('click touchend', function(event) {
			var row = this;
			var anchorclick = $(event.target).is('a');
			if (!anchorclick) {
				event.preventDefault();

				if (!dragging) {
					if ($('.complex-list-wrapper').hasClass('complex-list-wrapper-collapsible')) {
						$('.complex-custom-overlays img').removeClass('active').hide();
						activateProjectUnit($(this));
					} else {

						if ($('.complex-contact-form-wrapper').length) {
							// $('html, body').animate({
					  //       scrollTop: $('.complex-contact-form-wrapper').offset().top
					  //   }, 500);
					    $(".complex-contact-form-wrapper input:text, .complex-contact-form-wrapper textarea").first().focus();
					   	var unit_id = $(row).data('unit-id');
					    $('.complex-contact-form-wrapper form [name="complex-unit-inquiry[unit_id]"]').val(unit_id);
					    //.prop('disabled','disabled')


						} else if($(row).find('.col-quick-download a').length){
							$(row).find('.col-quick-download a').first()[0].trigger('click');
						} else if($(row).find('.col-quick-download').length){
							//silence
						} else {
							alert('form not found add it with [contactform-complex] or enable collapsible="1" property on [CXM-list] and make sure there is only one form available.');
						}
					}
				}
			}
		});

  //Nouislider Wohnfläche
  var rangeFlaeche = document.getElementById("filteroption-flaeche");
  var inputFlaecheFrom = document.getElementById("livingspace_from");
  var inputFlaecheTo = document.getElementById("livingspace_to");

  if (inputFlaecheFrom) {
    if (
      inputFlaecheFrom.value !== "" &&
      parseFloat(inputFlaecheFrom.value) !==
        Math.floor(parseFloat(inputFlaecheFrom.value))
    ) {
      inputFlaecheFrom.value = Math.floor(parseFloat(inputFlaecheFrom.value));
    }
  }
  if (inputFlaecheTo) {
    if (
      inputFlaecheTo.value !== "" &&
      parseFloat(inputFlaecheTo.value) !==
        Math.ceil(parseFloat(inputFlaecheTo.value))
    ) {
      inputFlaecheTo.value = Math.ceil(parseFloat(inputFlaecheTo.value));
    }
  }

  if (rangeFlaeche) {
    $("#livingspace_from").css("display", "none");
    $("#livingspace_to").css("display", "none");
    var sliderFlaecheMin = document.getElementById("filteroption-flaeche");
    var MinValueFlaeche = sliderFlaecheMin.getAttribute(
      "data-minlivingspace"
    );
    var MaxValueFlaeche = sliderFlaecheMin.getAttribute(
      "data-maxlivingspace"
    );
    var MinValueFlaeche = Math.round(Number(MinValueFlaeche));
    var MaxValueFlaeche = Math.round(Number(MaxValueFlaeche));

    if (MinValueFlaeche == MaxValueFlaeche) {
      MaxValueFlaeche = MinValueFlaeche + 1;
    }

    noUiSlider.create(rangeFlaeche, {
      start: [MinValueFlaeche, MaxValueFlaeche],
      step: 1, // Slider moves in increments of '10'
      margin: 1, // Handles must be more than '20' apart
      connect: true, // Display a colored bar between the handles
      direction: "ltr", // Put '0' at the bottom of the slider
      orientation: "horizontal", // Orient the slider vertically
      behaviour: "tap-drag", // Move handle on tap, bar is draggable
      range: {
        // Slider can select '0' to '100'
        min: MinValueFlaeche,
        max: MaxValueFlaeche,
      },
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    var flaecheSliderValues = [
      document.getElementById("flaeche-slider-lower-value"),
      document.getElementById("flaeche-slider-upper-value"),
    ];

    flaecheSliderValues[0].innerHTML = Math.round(MinValueFlaeche);
    flaecheSliderValues[1].innerHTML = Math.round(MaxValueFlaeche);

    rangeFlaeche.noUiSlider.on("update", function (values, handle) {
      flaecheSliderValues[handle].innerHTML = Math.round(values[handle]);
    });

    rangeFlaeche.noUiSlider.on("change", function (values, handle) {
      var value = values[handle];

      if (handle) {
        inputFlaecheTo.value = Math.round(value);
      } else {
        inputFlaecheFrom.value = Math.round(value);
      }
      $("#complexFilterForm").trigger('change');
    });

    inputFlaecheFrom.addEventListener("change", function () {
      rangeFlaeche.noUiSlider.set([Math.round(this.value), null]);
    });

    inputFlaecheTo.addEventListener("change", function () {
      rangeFlaeche.noUiSlider.set([null, Math.round(this.value)]);
    });
  }

  //Nouislider Miete Netto

  var rangeNettoMiete = document.getElementById("filteroption-miete-netto");
  var inputNettoMieteFrom = document.getElementById("rentnet_from");
  var inputNettoMieteTo = document.getElementById("rentnet_to");

  if (rangeNettoMiete) {
    $("#rentnet_from").css("display", "none");
    $("#rentnet_to").css("display", "none");
    var sliderMieteMin = document.getElementById("filteroption-miete-netto");
    var MinValueMiete = sliderMieteMin.getAttribute("data-minrentnet");
    var MaxValueMiete = sliderMieteMin.getAttribute("data-maxrentnet");
    var MinValueMiete = Math.round(Number(MinValueMiete));
    var MaxValueMiete = Math.round(Number(MaxValueMiete));
	console.log(MinValueMiete);
	console.log(MaxValueMiete);

    if (MinValueMiete == MaxValueMiete) {
      MaxValueMiete = MinValueMiete + 1;
    }

    noUiSlider.create(rangeNettoMiete, {
      start: [MinValueMiete, MaxValueMiete],
      step: 1, // Slider moves in increments of '10'
      margin: 1, // Handles must be more than '20' apart
      connect: true, // Display a colored bar between the handles
      direction: "ltr", // Put '0' at the bottom of the slider
      orientation: "horizontal", // Orient the slider vertically
      behaviour: "tap-drag", // Move handle on tap, bar is draggable
      range: {
        // Slider can select '0' to '100'
        min: MinValueMiete,
        max: MaxValueMiete,
      },
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    var mieteSliderValues = [
      document.getElementById("miete-slider-lower-value"),
      document.getElementById("miete-slider-upper-value"),
    ];

    mieteSliderValues[0].innerHTML = MinValueMiete;
    mieteSliderValues[1].innerHTML = MaxValueMiete;

    rangeNettoMiete.noUiSlider.on("update", function (values, handle) {
      mieteSliderValues[handle].innerHTML = values[handle];
    });

    rangeNettoMiete.noUiSlider.on("change", function (values, handle) {
      var value = values[handle];

      if (handle) {
        inputNettoMieteTo.value = Math.round(value);
      } else {
        inputNettoMieteFrom.value = Math.round(value);
      }
      $("#complexFilterForm").trigger('change');

	  	console.log(inputNettoMieteTo.value);
		console.log(inputNettoMieteFrom.value);
    });

    inputNettoMieteFrom.addEventListener("change", function () {
		rangeNettoMiete.noUiSlider.set([Math.round(this.value), null]);
    });

    inputNettoMieteTo.addEventListener("change", function () {
		rangeNettoMiete.noUiSlider.set([null, Math.round(this.value)]);
    });
  }

  //Nouislider Miete Brutto

  var rangeMiete = document.getElementById("filteroption-miete-grossto");
  var inputMieteFrom = document.getElementById("rentgross_from");
  var inputMieteTo = document.getElementById("rentgross_to");

  if (rangeMiete) {
    $("#rentgross_from").css("display", "none");
    $("#rentgross_to").css("display", "none");
    var sliderMieteMin = document.getElementById("filteroption-miete-grossto");
    var MinValueMiete = sliderMieteMin.getAttribute("data-minrentgross");
    var MaxValueMiete = sliderMieteMin.getAttribute("data-maxrentgross");
    var MinValueMiete = Math.round(Number(MinValueMiete));
    var MaxValueMiete = Math.round(Number(MaxValueMiete));

    if (MinValueMiete == MaxValueMiete) {
      MaxValueMiete = MinValueMiete + 1;
    }

    noUiSlider.create(rangeMiete, {
      start: [MinValueMiete, MaxValueMiete],
      step: 1, // Slider moves in increments of '10'
      margin: 1, // Handles must be more than '20' apart
      connect: true, // Display a colored bar between the handles
      direction: "ltr", // Put '0' at the bottom of the slider
      orientation: "horizontal", // Orient the slider vertically
      behaviour: "tap-drag", // Move handle on tap, bar is draggable
      range: {
        // Slider can select '0' to '100'
        min: MinValueMiete,
        max: MaxValueMiete,
      },
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    var mieteSliderValues = [
      document.getElementById("miete-slider-lower-value"),
      document.getElementById("miete-slider-upper-value"),
    ];

    mieteSliderValues[0].innerHTML = MinValueMiete;
    mieteSliderValues[1].innerHTML = MaxValueMiete;

    rangeMiete.noUiSlider.on("update", function (values, handle) {
      mieteSliderValues[handle].innerHTML = values[handle];
    });

    rangeMiete.noUiSlider.on("change", function (values, handle) {
      var value = values[handle];

      if (handle) {
        inputMieteTo.value = Math.round(value);
      } else {
        inputMieteFrom.value = Math.round(value);
      }
      $("#complexFilterForm").trigger('change');
    });

    inputMieteFrom.addEventListener("change", function () {
      rangeMiete.noUiSlider.set([Math.round(this.value), null]);
    });

    inputMieteTo.addEventListener("change", function () {
      rangeMiete.noUiSlider.set([null, Math.round(this.value)]);
    });

    
  }

  //Nouislider Kauf

  var rangeKauf = document.getElementById("filteroption-purchase-price");
  var inputKaufFrom = document.getElementById("purchaseprice_from");
  var inputKaufTo = document.getElementById("purchaseprice_to");

  if (rangeKauf) {
    $("#purchaseprice_from").css("display", "none");
    $("#purchaseprice_to").css("display", "none");
    var sliderKaufMin = document.getElementById(
      "filteroption-purchase-price"
    );
    var MinValueKauf = sliderKaufMin.getAttribute("data-minpurchaseprice");
    var MaxValueKauf = sliderKaufMin.getAttribute("data-maxpurchaseprice");
    var MinValueKauf = Math.round(Number(MinValueKauf));
    var MaxValueKauf = Math.round(Number(MaxValueKauf));

    if (MinValueKauf == MaxValueKauf) {
      MaxValueKauf = MinValueKauf + 1;
    }

    noUiSlider.create(rangeKauf, {
      start: [MinValueKauf, MaxValueKauf],
      step: 1, // Slider moves in increments of '10'
      margin: 1, // Handles must be more than '20' apart
      connect: true, // Display a colored bar between the handles
      direction: "ltr", // Put '0' at the bottom of the slider
      orientation: "horizontal", // Orient the slider vertically
      behaviour: "tap-drag", // Move handle on tap, bar is draggable
      range: {
        // Slider can select '0' to '100'
        min: MinValueKauf,
        max: MaxValueKauf,
      },
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    var kaufSliderValues = [
      document.getElementById("kauf-slider-lower-value"),
      document.getElementById("kauf-slider-upper-value"),
    ];

    kaufSliderValues[0].innerHTML = MinValueKauf;
    kaufSliderValues[1].innerHTML = MaxValueKauf;

    rangeKauf.noUiSlider.on("update", function (values, handle) {
      kaufSliderValues[handle].innerHTML = values[handle];
    });

    rangeKauf.noUiSlider.on("change", function (values, handle) {
      var value = values[handle];

      if (handle) {
        inputKaufTo.value = Math.round(value);
      } else {
        inputKaufFrom.value = Math.round(value);
      }
      $("#complexFilterForm").trigger('change');
    });

    inputKaufFrom.addEventListener("change", function () {
      rangeKauf.noUiSlider.set([Math.round(this.value), null]);
    });

    inputKaufTo.addEventListener("change", function () {
      rangeKauf.noUiSlider.set([null, Math.round(this.value)]);
    });
  }

});



// WEBPACK FOOTER //
// ./src/js/main.js